import React from "react";
import useTimerCounter from "../hooks/use-timer";

export default function RemainigTime({ time }) {
  const { full } = useTimerCounter(time);

  return <>{full}</>;
}
